import { render, staticRenderFns } from "./activityDetail.vue?vue&type=template&id=473ea940&scoped=true&"
import script from "./activityDetail.vue?vue&type=script&lang=js&"
export * from "./activityDetail.vue?vue&type=script&lang=js&"
import style0 from "./activityDetail.vue?vue&type=style&index=0&id=473ea940&prod&scoped=true&lang=css&"
import style1 from "./activityDetail.vue?vue&type=style&index=1&id=473ea940&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473ea940",
  null
  
)

export default component.exports